import dayjs from 'dayjs'

//export const startDate = (dayjs().$y - 1).toString() + '-10-02'
export const startDateHome = dayjs().day(-71).format('YYYY-MM-DD')
export const startDate = dayjs().day(-365).format('YYYY-MM-DD')
export const endDate = dayjs().day(-15).format('YYYY-MM-DD')
//dayjs().day(0).add(182, 'day').format('YYYY-MM-DD') //someFutureSunday
export const displayDate = dayjs().day(-1).format('YYYY-MM-DD')
export const lastweekEndDate = dayjs().day(-15).format('YYYY-MM-DD')
